module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "message"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "message-content",
    class: _vm.type
  }, [_c('y-svg', {
    staticClass: "message-info",
    attrs: {
      "type": _vm.svgClass
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-bda1f366!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/message/message.vue
// module id = 497
// module chunks = 27